import actions from './actions';

const initialState = {
    client_id: null,
    institute_id: null,
};

const { SET_AUTH_PARAMS, CLEAR_AUTH_PARAMS } = actions;

const authParamsReducer = (state = initialState, action) => {
    const { type, client_id, institute_id } = action;
    
    switch (type) {
        case SET_AUTH_PARAMS:
            console.log('[Redux] Auth params saved to store:', {
                client_id,
                institute_id,
                previous_state: state
            });
            
            // Also ensure sessionStorage is updated
            if (client_id) {
                sessionStorage.setItem('client_id', client_id);
            }
            if (institute_id) {
                sessionStorage.setItem('institute_id', institute_id);
            }
            
            return {
                ...state,
                client_id,
                institute_id,
            };
        case CLEAR_AUTH_PARAMS:
            console.log('[Redux] Auth params cleared from store');
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default authParamsReducer;

